import { useContext } from 'react';
import { useTranslation } from 'src/hooks';
import { Context } from './BlobContext';

export const useBlobContext = () => {
  const { t } = useTranslation();
  const blobContext = useContext(Context);

  if (blobContext === undefined) {
    throw new Error(t('errors.validation.context', { contextName: 'Blob' }));
  }

  return blobContext;
};
